import React, { useEffect, useState } from "react";

import {
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithPopup,
    signOut
} from "firebase/auth";

import {
    doc,
    getDoc
} from "firebase/firestore";

import {
    auth,
    db
} from "../../services/firebase";

import AdminObras from "./AdminObras";
import AdminCapitulos from "./AdminCapitulos";
import AdminAdministradores from "./AdminAdministradores";


const Admin = () => {

    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [activeTab, setActiveTab] = useState("obras");


    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, async currentUser => {

            setLoading(true);
            setUser(currentUser);
            setIsAdmin(false);

            if (!currentUser) {
                setLoading(false);
                return;
            }

            try {

                const adminEmail = currentUser.email.toLowerCase();

                const adminRef = doc(
                    db,
                    "admins",
                    adminEmail
                );

                const adminSnap = await getDoc(adminRef);

                setIsAdmin(adminSnap.exists());

            } catch (error) {

                console.error(error);
                setIsAdmin(false);

            } finally {

                setLoading(false);

            }

        });

        return () => unsubscribe();

    }, []);


    const handleGoogleLogin = async () => {

        setError("");

        try {

            const provider = new GoogleAuthProvider();

            await signInWithPopup(
                auth,
                provider
            );

        } catch (error) {

            console.error(error);

            setError(
                "No se pudo iniciar sesión con Google."
            );

        }

    };


    const handleLogout = async () => {

        try {

            await signOut(auth);

        } catch (error) {

            console.error(error);

        }

    };


    if (loading) {

        return (
            <div className="admin">
                <p>Cargando...</p>
            </div>
        );

    }


    if (!user) {

        return (
            <div className="admin admin-login">

                <h1>Administración</h1>

                <p>
                    Ingresá con tu cuenta de Google para administrar Primitiva.
                </p>

                {error &&
                    <p className="admin-error">
                        {error}
                    </p>
                }

                <button onClick={handleGoogleLogin}>
                    Ingresar con Google
                </button>

            </div>
        );

    }


    if (!isAdmin) {

        return (
            <div className="admin admin-login">

                <h1>Acceso no autorizado</h1>

                <p>
                    La cuenta {user.email} no tiene permisos para acceder al administrador.
                </p>

                <button onClick={handleLogout}>
                    Cerrar sesión
                </button>

            </div>
        );

    }


    return (
        <div className="admin">

            <div className="admin-header">

                <div>
                    <h1>Administración</h1>
                    <p>{user.email}</p>
                </div>

                <button onClick={handleLogout}>
                    Cerrar sesión
                </button>

            </div>


            <div className="admin-tabs">

                <button
                    type="button"
                    className={activeTab === "obras" ? "active" : ""}
                    onClick={() => setActiveTab("obras")}
                >
                    Obras
                </button>

                <button
                    type="button"
                    className={activeTab === "capitulos" ? "active" : ""}
                    onClick={() => setActiveTab("capitulos")}
                >
                    Capítulos
                </button>

                <button
                    type="button"
                    className={activeTab === "administradores" ? "active" : ""}
                    onClick={() => setActiveTab("administradores")}
                >
                    Administradores
                </button>

            </div>


            <div className="admin-content">

                {activeTab === "obras" &&
                    <AdminObras />
                }

                {activeTab === "capitulos" &&
                    <AdminCapitulos />
                }

                {activeTab === "administradores" &&
                    <AdminAdministradores
                        currentUserEmail={user.email}
                    />
                }

            </div>

        </div>
    );

};


export default Admin;